module.exports = __webpack_public_path__ + "img/pic2@2x.43c8cad8.png";